import React from 'react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';

const insertBrAfterThirdSpace = (str) => {
  let spaceCount = 0;
  let position = -1;

  if (str) {
    for (let i = 0; i < str.length; i++) {
      if (str[i] === ' ') {
        spaceCount++;
        if (spaceCount === 2) {
          position = i;
          break;
        }
      }
    }
  }

  let part1 = '';
  let part2 = '';

  if (position !== -1) {
    part1 = str.substring(0, position);
    part2 = str.substring(position + 1);

    return (
      <Tooltip
        title={part1 + ' ' + part2}
        arrow
        placement='top'
      >
        {part1}....
      </Tooltip>
    );
  } else {
    return str;
  }
};

export default insertBrAfterThirdSpace;
